interface TypingIndicatorProps {
  text?: string
}

export function TypingIndicator({ text = 'Typing...' }: TypingIndicatorProps) {
  return (
    <div className="flex items-center space-x-2 text-gray-500 text-sm">
      <div className="flex space-x-1">
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" />
        <div
          className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: '0.1s' }}
        />
        <div
          className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: '0.2s' }}
        />
      </div>
      <span>{text}</span>
    </div>
  )
}
